<div class="overlaySpinner" *ngIf="showSpinner">
  <p-progressSpinner class="querySpinner"></p-progressSpinner>
</div>